// Publishes a navigation_tile_clicked event that web pixels can subscribe to.
document.addEventListener('click', (event) => {
  const link = event.target.closest('.navigation-tiles__link');
  if (!link || !window.Shopify?.analytics?.publish) return;
  window.Shopify.analytics.publish('navigation_tile_clicked', {
    collection: link.closest('.navigation-tiles').dataset.collection,
    label: link.dataset.tileLabel,
    position: Number(link.dataset.tilePosition),
    url: link.getAttribute('href'),
  });
});
